export default __webpack_public_path__ + "static/media/appStatusPending.f14cf76b.png";